<template>
  <div id="menu">
    <v-navigation-drawer v-model="drawer" app clipped>
      <v-list dense>
        <v-list-item link :to="{ name: 'home' }" exact>
          <v-list-item-action>
            <v-icon>mdi-home</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Home</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item link :to="{ name: 'privacy' }" exact>
          <v-list-item-action>
            <v-icon>mdi-text-box</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Privacy Policy</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <!-- <v-list-item link :to="{ name: 'contact_us' }">
          <v-list-item-action>
            <v-icon>mdi-email</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Contact Us</v-list-item-title>
          </v-list-item-content>
        </v-list-item> -->

        <v-list-item link :to="{ name: 'performers' }">
          <v-list-item-action>
            <v-icon>mdi-account-multiple</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Performers</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item link :to="{ name: 'categories' }">
          <v-list-item-action>
            <v-icon>mdi-alpha-a-box</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Categories</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item link :to="{ name: 'songs' }">
          <v-list-item-action>
            <v-icon>mdi-music-box-multiple</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Songs</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-divider v-if="isAuthenticated" class="menu-divider"></v-divider>

        <v-list-item link :to="{ name: 'create_user' }" v-if="isAuthenticated">
          <v-list-item-action>
            <v-icon>mdi-cog</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Create User</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item link @click="logOut" v-if="isAuthenticated">
          <v-list-item-action>
            <v-icon>mdi-exit-run</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Log Out</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar app clipped-left>
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <v-toolbar-title>Music Head</v-toolbar-title>
    </v-app-bar>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "Menu",
  data: () => ({
    drawer: null,
  }),
  computed: {
    ...mapGetters("auth", ["isAuthenticated"]),
  },
  methods: {
    logOut() {
      this.$store.dispatch("auth/logout").then(() => {
        if (this.$route.name === "home") return;
        this.$router.push({
          name: "home",
        });
      });
    },
  },
};
</script>

<style>
.menu-divider {
  margin-top: 8px;
  margin-bottom: 8px;
}
</style>
